module.exports = __webpack_public_path__ + "static/img/icon0.4325c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon0.png
// module id = SMDe
// module chunks = 0